import React from 'react';
import PropTypes from 'prop-types';
import RichTextEditor from '../../RichTextEditor/RichText';

const CardDescription = ({ props }) => {
    const { cardContent } = props;
    return (
        <div className="card__description" data-cy="contactcard-description">
            <RichTextEditor data={cardContent} />
        </div>
    );
};
CardDescription.propTypes = {
    props: PropTypes.object,
    cardContent: PropTypes.string,
};
export default CardDescription;
